import { render, staticRenderFns } from "./EditQuestionFooter.vue?vue&type=template&id=6787ebd4&scoped=true&"
import script from "./EditQuestionFooter.vue?vue&type=script&lang=ts&"
export * from "./EditQuestionFooter.vue?vue&type=script&lang=ts&"
import style0 from "./EditQuestionFooter.vue?vue&type=style&index=0&id=6787ebd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6787ebd4",
  null
  
)

export default component.exports